import React from "react";
import DropDown from "../../../dropDowns/dropDown/DropDownComponent";
import AppService from "../../../../service/AppService";
import { appList } from "../../../../service/survey";

const surveyTypes = [...appList.map((app) => ({ text: app.label, value: app.key }))];

function InfoTab({ appType, appTypeChanged, title, setTitle, description, setDescription }) {
    const handleChange = ({ target }) => {
        switch (target.name) {
            case "title":
                setTitle(AppService.trimSpaces(target.value));
                break;
            case "description":
                setDescription(AppService.trimSpaces(target.value));
                break;
        }
    };

    // DropDown passes the translated `item.text` as the first `onChange` arg and
    // the whole item as the second. We need the backend enum (`item.value`), so we
    // ignore the first arg and read `item.value` instead. This lets us show a pretty
    // label like "MILK DONATION" while keeping `appType` as "MILK_DONATION".
    const handleAppTypeChange = (_label, item) => appTypeChanged(item.value);
    const selectedAppTypeLabel = surveyTypes.find((type) => type.value === appType)?.text ?? "";

    return (
        <div className="content">
            <div>
                <div className="sub-header">info</div>
                <div className="group-col">
                    <div className="one-col app-type">
                        <DropDown
                            label="Application Type"
                            isDisabled={!!AppService.selectedApp}
                            required={true}
                            selectedItem={selectedAppTypeLabel}
                            placeholder="Select type"
                            items={surveyTypes}
                            onChange={handleAppTypeChange}
                        />
                    </div>
                    <div className="one-col">
                        <label>
                            Title <span className="required">*</span>
                        </label>
                        <input type="text" placeholder="Name your survey" name="title" value={title} onChange={handleChange} />
                    </div>
                </div>
                <div className="one-col app-description">
                    <label>
                        Description <span className="required">*</span>
                    </label>
                    <input type="text" placeholder="Describe this survey" name="description" value={description} onChange={handleChange} />
                </div>
            </div>
        </div>
    );
}

export default InfoTab;
